// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-f4c7aacc],\n.fade-leave-active[data-v-f4c7aacc] {\n  transition: all 0.5s ease;\n}\n.fade-enter-from[data-v-f4c7aacc],\n.fade-leave-to[data-v-f4c7aacc] {\n  transform: translateY(-20%);\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
